import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sanitizeWhiteSpace',
})
@Injectable({
  providedIn: 'root',
})
export class SanitizeWhiteSpacePipe implements PipeTransform {
  transform(text: string): string {
    if (!text || typeof text !== 'string') {
      return '';
    }


    return text.replace(/&nbsp;/g, ' ');
  }
}
